import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      dir="rtl"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'shadow-xl' : ''
      }`}
    >
      <div className="bg-gradient-to-l from-gray-900 via-gray-800 to-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">

            {/* Logo */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                <span className="font-bold">WN</span>
              </div>
              <span className="text-xl font-bold text-green-400">
                الوسيط الناقل
              </span>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden md:flex gap-8">
              <Link to="/">الرئيسية</Link>
              <a href="#about">حول</a>
              <a href="#services">خدماتنا</a>
              <a href="#partners">شركاؤنا</a>
              <a href="#contact">اتصال</a>
            </nav>

            {/* Mobile Button */}
            <button
              className="md:hidden"
              onClick={() => setOpen(!open)}
            >
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {open && (
          <div className="md:hidden bg-gray-900 border-t border-gray-700">
            <div className="flex flex-col text-right px-6 py-4 gap-4">
              <Link to="/" onClick={() => setOpen(false)}>الرئيسية</Link>
              <a href="#about" onClick={() => setOpen(false)}>حول</a>
              <a href="#services" onClick={() => setOpen(false)}>خدماتنا</a>
              <a href="#partners" onClick={() => setOpen(false)}>شركاؤنا</a>
              <a href="#contact" onClick={() => setOpen(false)}>اتصال</a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
